export const TenantUserStatusList = [
  "active",
  "inactive",
  "pending",
  "suspended",
] as const;

export const TenantUserThingTypeMrn = "mrn:sl2:::tenantUser";
